export default class GalleryImage {

    constructor(data) {
        this.data = data;
        this.display = false;
        this.sourceApplied = false;
        this.loading = false;
        this.isYouTube = false;
        this.youTubeHash = this.getYoutubeHash(this.data.url);
        this.width = 0;
        this.height = 0;
        this.customData = null;
        this.customDataError = null;

        if(!this.data.file_id) {
            this.data.file_id = this.data.url;
        }
    }

    loadSource(callback = null) {
        if (this.sourceApplied) {
            return;
        }
        this.loading = true;
        this.sourceApplied = true;

        if (this.youTubeHash) {
            this.loadYouTube(callback);
        } else {
            this.loadImage(callback);
        }
    }

    loadYouTube(callback) {
        this.src = 'https://www.youtube.com/embed/' + this.youTubeHash;
        this.loading = false;
        this.show();

        if (callback) {
            callback('video', null, this);
        }
    }

    loadImage(callback) {
        let img = new Image();
        img.src = this.data.url;
        img.onload = () => {
            this.src = this.data.url;
            this.loading = false;
            this.show();
            if (callback) {
                callback('image', img, this);
            }
        }
    }

    show() {
        this.display = true;
    }

    hide() {
        this.display = false;
    }

    getYoutubeHash(url) {
        let regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:shorts\/)?(?:[^\/\n\s]+\/)?|watch\/(?:[^\/\n\s]+\/)?|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/|\S*?[?&]video_id=|youtu\.be\/|embed\/|watch\?v(?:i)?=)([^#\&\?\n\s]{11})/;
        let match = url.match(regExp);

        if (match && match[1].length == 11) {
            return match[1];
        }

        let imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }

    setCustomData(data = null) {
        this.customData = data;
    }

    setCustomDataError(message = null) {
        this.customDataError = message;
    }

}
